import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createGetServerSideProps } from '../models/functions/get-server-side-props';
import { RootStoreHydration } from '../models/stores/root-store';
import { Layout } from '../blocks/web/layout/layout';
import { Faq } from '../blocks/web/faq/faq';
import { HomepagePricing } from '../blocks/web/pricing/homepage-pricing';
import { SubpageHero } from '../components/web/subpage-hero/subpage-hero';
import { getAvailablePremiumLookupKeysFromCookie } from '../models/functions/pricing-offer';

const FaqPage: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <Layout
            introAppearance="subpage"
            intro={
                <SubpageHero title={t('pages.faq.title')} description={t('pages.faq.heroDescription')} visual="help" />
            }
        >
            <Faq />
            <HomepagePricing />
        </Layout>
    );
});

export const getServerSideProps = createGetServerSideProps(async (rootStore, context) => {
    const initialData: RootStoreHydration = {
        availablePremiumLookupKeys: getAvailablePremiumLookupKeysFromCookie(context.req?.headers.cookie),
        authStore: rootStore.authStore.hydrate(),
        themeStore: rootStore.themeStore.hydrate(),
        userStore: rootStore.userStore.hydrate(),
        competitionDialogStore: rootStore.competitionDialogStore.hydrate(),
    };

    return initialData;
}, false);

export default FaqPage;
